module.exports = __webpack_public_path__ + "static/img/khk-003.353e76ea.jpg";